const BASE = process.env.REACT_APP_API_URL;
// const BASE = 'http://192.168.0.107:4000/api';

async function req(method, path, token, body) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res  = await fetch(`${BASE}${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'API error');
  return data;
}

export const booksAPI = {
  getFilters: ()                  => req('GET', '/books/filters'),
  getBooks:   (t, p = {})         => req('GET', `/books?${new URLSearchParams(p)}`, t),
  getBook:    (t, id)             => req('GET', `/books/${id}`, t),
  getChapters:(t, id, p = {})     => req('GET', `/books/${id}/chapters?${new URLSearchParams(p)}`, t),
  getChapter: (t, bookId, chapterId, p = {}) => req('GET', `/books/${bookId}/chapters/${chapterId}?${new URLSearchParams(p)}`, t),
  getSidebar: (t, id)             => req('GET', `/books/${id}/sidebar`, t),
};

export const searchAPI = {
  search: (t, p = {}) => req('GET', `/search?${new URLSearchParams(p)}`, t),
};

export const compilationsAPI = {
  getSubjects:    ()          => req('GET', '/compilations/subjects'),
  getAll:         (t, p = {}) => req('GET', `/compilations?${new URLSearchParams(p)}`, t),
  getOne:         (t, id)     => req('GET', `/compilations/${id}`, t),
};

export const archiveAPI = {
  getTitles: (t)         => req('GET', '/archive/titles', t),
  getAll:    (t, p = {}) => req('GET', `/archive?${new URLSearchParams(p)}`, t),
  getOne:    (t, id)     => req('GET', `/archive/${id}`, t),
};

export const usersAPI = {
  getMe:          (t)         => req('GET',   '/users/me', t),
  updateMe:       (t, b)      => req('PATCH', '/users/me', t, b),
 toggleBookmark: (t, bookId, body) => req('POST', `/users/bookmarks/${bookId}`, t, body),
  toggleDownload: (t, bookId) => req('POST',  `/users/downloads/${bookId}`, t),
  saveProgress:   (t, b)      => req('POST',  '/users/progress', t, b),
};

export const notebooksAPI = {
  getAll: (t, p = {}) => req('GET',    `/notebooks?${new URLSearchParams(p)}`, t),
  create: (t, b)      => req('POST',   '/notebooks', t, b),
  update: (t, id, b)  => req('PATCH',  `/notebooks/${id}`, t, b),
  remove: (t, id)     => req('DELETE', `/notebooks/${id}`, t),
};